const options = {
  5: "bg-zinc-600/5",
  10: "bg-zinc-600/10",
  25: "bg-zinc-600/25",
  50: "bg-zinc-600/50",
  75: "bg-zinc-600/75",
  90: "bg-zinc-600/90",
  100: "bg-zinc-600",
};

const from = {
  5: "from-zinc-600/5",
  10: "from-zinc-600/10",
  25: "from-zinc-600/25",
  50: "from-zinc-600/50",
  75: "from-zinc-600/75",
  90: "from-zinc-600/90",
  100: "from-zinc-600",
};

export default function getBackgroundZinc600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
